import { applyMiddleware, createStore, combineReducers } from 'redux';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import { createChordClient } from '../../services/chord';
import * as defaultReducer from '../reducers';
import defaultInitialState from './initial-state';
import { analytics as createAnalyticsMiddleware, persist as persistMiddleware, session as sessionMiddleware } from '../middleware';
import { initializeState } from '../actions';
const isBrowser = typeof window !== 'undefined';
const enhancers = composeWithDevToolsDevelopmentOnly({});
const createAppStore = _ref => {
  let {
    config,
    middleware = [],
    preloadedState = {},
    reducer = {},
    auth
  } = _ref;
  const storeReducer = combineReducers({
    ...defaultReducer,
    ...reducer
  });
  const storePreloadedState = {
    ...defaultInitialState,
    ...preloadedState
  };
  const chord = createChordClient(config);
  const analyticsMiddleware = createAnalyticsMiddleware({
    chord
  });
  const storeEnhancer = enhancers(applyMiddleware(thunk.withExtraArgument({
    auth,
    chord,
    config
  }), persistMiddleware, analyticsMiddleware, sessionMiddleware, ...middleware));
  const store = createStore(storeReducer, storePreloadedState, storeEnhancer);
  if (isBrowser) {
    store.dispatch(initializeState());
  }
  return store;
};
export default createAppStore;